import { useEffect } from 'react';

import type { LoanProcessStateKeys } from '../store/loan-process.store';
import { LOAN_PROCESS_STATE, useLoanProcessStore } from '../store/loan-process.store';

const _componentNames = {
  ApplicationProcessing: 'ApplicationProcessing',
  AgreementAndApprovals: 'AgreementAndApprovals',
  AgreementProcessing: 'AgreementProcessing',
  ApplicationPositive: 'ApplicationPositive',
  ApplicationNegative: 'ApplicationNegative',
  AgreementSmsConfirmation: 'AgreementSmsConfirmation',
  AgreementLiberisIframe: 'AgreementLiberisIframe',
  AgreementSuccessful: 'AgreementSuccessful',
  AgreementSmsTooManyAttempts: 'AgreementSmsTooManyAttempts',
  ApplicationSuspended: 'ApplicationSuspended',
  ApplicationChangedLoanAmount: 'ApplicationChangedLoanAmount',
} as const;

const LOAN_PROCESS_MODAL_COMPONENTS: Record<keyof typeof _componentNames, LoanProcessStateKeys> = {
  ApplicationProcessing: LOAN_PROCESS_STATE.APPLICATION_PROCESSING,
  AgreementAndApprovals: LOAN_PROCESS_STATE.AGREEMENT_AND_APPROVALS,
  AgreementProcessing: LOAN_PROCESS_STATE.AGREEMENT_AND_APPROVALS_PROCESSING,
  ApplicationPositive: LOAN_PROCESS_STATE.APPLICATION_POSITIVE,
  ApplicationNegative: LOAN_PROCESS_STATE.APPLICATION_NEGATIVE,
  AgreementSmsConfirmation: LOAN_PROCESS_STATE.AGREEMENT_SMS_CONFIRMATION,
  AgreementLiberisIframe: LOAN_PROCESS_STATE.AGREEMENT_LIBERIS_IFRAME,
  AgreementSuccessful: LOAN_PROCESS_STATE.AGREEMENT_SUCCESSFUL_SIGNED,
  AgreementSmsTooManyAttempts: LOAN_PROCESS_STATE.AGREEMENT_SMS_TOO_MANY_ATTEMPTS,
  ApplicationSuspended: LOAN_PROCESS_STATE.APPLICATION_SUSPENDED,
  ApplicationChangedLoanAmount: LOAN_PROCESS_STATE.APPLICATION_CHANGED_LOAN_AMOUNT,
} as const;

/**
 * This hook is used to set modal state - currently displayed view in loan's store.
 * It's vital to call this hook in every loan modal view.
 */
export function useLoanProcessSetCurrentModalState(componentName: keyof typeof _componentNames) {
  const {
    actions: { setLoanProcessState },
  } = useLoanProcessStore();
  useEffect(() => {
    setLoanProcessState(LOAN_PROCESS_MODAL_COMPONENTS[componentName]);

    return () => {
      setLoanProcessState();
    };
  }, [componentName, setLoanProcessState]);
}
